export default __webpack_public_path__ + "static/media/logo_white.11a0eb77.jpg";